import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CentrosService } from 'src/app/dashboard/services/centros.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Empresa } from 'src/app/dashboard/models/empresa';
import { CustomValidators } from 'src/app/shared/custom-validator/custom-validator.component';
import { ApiService } from 'src/app/shared/services/api.service';


@Component({
  selector: 'app-add-center',
  templateUrl: './add-center.component.html',
  styleUrls: ['./add-center.component.css']
})
export class AddCenterComponent implements OnInit {

  validatingForm: FormGroup;
  empresas: Empresa[] = [];
  sociedad: string;

  constructor(
    private apiService: ApiService,
    private centersService: CentrosService,
    private auth: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    const language = this.auth.getLanguage() || 'es';
    this.translate.setDefaultLang(language);

    this.sociedad = this.auth.getNameSociedad();

    this.validatingForm = new FormGroup({
      signupFormModalName: new FormControl('', [
        Validators.required,
        Validators.maxLength(255),
        Validators.pattern(/^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑ.,()\-_\[\]\/"']{2,255}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalId: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9_-]{1,100}$/),
        CustomValidators.secureInput
      ]),
      signupFormModalidEmpresa: new FormControl('', [
        Validators.required
      ]),
      contactFormModalMessage: new FormControl('', [
        Validators.maxLength(4000),
        CustomValidators.secureInput
      ])
    });
    this.apiService
      .searchCompanyByUser(this.auth.getSociedad())
      .subscribe({
        next: (res) => {
          if (res.code === 200 && res.success) {
            this.empresas = res.data;
          }
        },
        error: (err) => {
          if (err.error.code !== 404 ){
            this.toastr.error(this.translate.instant('texto_890'),this.translate.instant('texto_896'));
          }
          this.empresas = [];
        }
      });
  }

  get signupFormModalId() {
    return this.validatingForm.get('signupFormModalId');
  }

  get signupFormModalName() {
    return this.validatingForm.get('signupFormModalName');
  }

  get signupFormModalidEmpresa() {
    return this.validatingForm.get('signupFormModalidEmpresa');
  }

  get contactFormModalMessage() {
    return this.validatingForm.get('contactFormModalMessage');
  }

  addCenter(): void {
    if (this.validatingForm.invalid) {
      this.toastr.warning(this.translate.instant('texto_61'), this.translate.instant('texto_684'));
      return;
    }

    this.centersService.addCenter(
      this.auth.getSociedad(),
      this.signupFormModalId.value,
      this.signupFormModalName.value,
      this.signupFormModalidEmpresa.value,
      this.contactFormModalMessage.value
    ).subscribe(
      res => {
        if ((res as any).success === true) {
          this.toastr.success(this.translate.instant('texto_683'), this.translate.instant('texto_684'));
        } else {
          this.toastr.error(this.translate.instant('texto_685'), this.translate.instant('texto_684'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/dashboard/layout/centros']);
        });
      },
      err => {
        if (err.status === 409) {
          this.toastr.error(this.translate.instant('texto_685'), this.translate.instant('texto_813'));
        } else {
          this.toastr.error(this.translate.instant('texto_685'), this.translate.instant('texto_813'));
        }
      });
  }
}
